"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Seagate = function Seagate(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M8.315 1.735c.277-.166.554-.333.831-.443.111.277.277.554.388.83-.61.333-1.219.61-1.772.997-8.149 4.948-6.9 10.574-3.379 11.077 2.399.45 5.343-1.094 7.422-2.326 1.575-.985 2.99-1.926 2.99-3.046 0-.713-.824-1.053-1.495-.942-2.167.542-5.07 3.545-7.477 3.545-1.097 0-1.895-.842-1.772-1.828.154-1.843 1.891-3.229 3.49-4.154 2.585-1.696 6.02-3.199 9.082-3.046 7.647.264 12.227 9.815-.997 18.167-1.501.948-3.92 1.99-4.43 2.16-.222-.997-.554-1.994-.776-2.991 2.421-1.14 3.145-1.281 5.816-3.323 2.243-1.795 4.4-3.917 4.763-6.813.055-.664.055-1.274-.111-1.938-.901-3.09-5.07-6.275-12.905-1.052-.815.475-2.16 1.436-2.16 2.381 0 .222.166.499.388.554 1.204.516 3.881-2.192 6.535-3.102 2.08-.734 4.175.047 4.542 1.884.055.498.055.996-.11 1.44-.594 1.541-2.025 2.658-3.49 3.6-1.53.842-3.087 2.042-6.48 2.935-2.315.631-5.267.29-6.48-1.772-.499-.776-.72-1.717-.72-2.603.055-1.053.277-2.105.72-3.047.775-1.606 1.938-3.046 3.323-4.209a23.121 23.121 0 0 1 4.32-2.99z"
  }));
};

Seagate.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Seagate.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Seagate;
exports.default = _default;